module.exports = __webpack_public_path__ + "d563b22eb1ec0645a17e394caaaf3c20.png";